module.exports = __webpack_public_path__ + "7e996fdb62018a28f83d661d3d2901b1.svg";